import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import {
    InfoElement,
    InfoIconBox,
    DividendBox,
} from 'src/domains/sportsbook/webview/components/raceCard/raceResults/DividendsInfo.style';
import { useCommon } from 'src/domains/common/Common';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface DividendsViewType {
    forecast: number | undefined;
    tricast: number | undefined;
}

export const getDividends = (race: EventModel, models: ModelsState): DividendsViewType | null => {
    const market = race.marketsAll.find((m) => {
        const marketModel = models.getMarket(m.id);
        return marketModel !== null && marketModel.dividends !== null;
    });

    if (market === undefined) {
        return null;
    }

    const marketModel = models.getMarket(market.id);
    if (marketModel === null || marketModel.dividends === null) {
        return null;
    }

    const dividends = marketModel.dividends;

    return {
        forecast: dividends.forecast?.at(0)?.dividend,
        tricast: dividends.tricast?.at(0)?.dividend,
    };
};

interface DividendsInfoPropsType {
    models: ModelsState;
    race: EventModel;
}

export const DividendsInfo = observer(
    'DividendsInfo',
    ({ models, race }: DividendsInfoPropsType): JSX.Element | null => {
        const common = useCommon();
        const moneySymbol = BasicDataModel.get(common).moneySymbol;
        const configState = ConfigComponents.get(common).config;
        const dividends = getDividends(race, models);

        if (dividends === null) {
            return null;
        }

        if (dividends.forecast === undefined && dividends.tricast === undefined) {
            return null;
        }

        return (
            <DividendBox variant={configState.componentVariants.sportsbookVariant}>
                <InfoIconBox />

                {dividends.forecast !== undefined && (
                    <InfoElement>
                        <I18n
                            langKey='events.race-card.results.forecast'
                            defaultText='Forecast'
                        />
                        : {moneySymbol}
                        {dividends.forecast}
                    </InfoElement>
                )}

                {dividends.tricast !== undefined && (
                    <InfoElement>
                        <I18n
                            langKey='events.race-card.results.tricast'
                            defaultText='Tricast'
                        />
                        : {moneySymbol}
                        {dividends.tricast}
                    </InfoElement>
                )}
            </DividendBox>
        );
    }
);
